import React from 'react';
import {ErrorMessage, Form, Formik} from 'formik';
import InputText from 'components/InputText';
import Button from 'components/Button';
import Title from 'components/Typography/Title';
import {ErrorIcon, ArrowIcon} from 'icons';

import Agreement from '../../components/Agreement';
import FacebookButton from '../../components/FacebookButton';
import AuthForm from '../../components/AuthForm';
import validate from './signUpValidations';
import {signUpWithEmailAndPassword} from './signUpHelpers';
import './signUp.scss';

const initialValues = {email: '', password: ''};
const callToAction = 'Create Account or Continue';

export default ({history}) => (
  <AuthForm className="sign-up">
    <Formik initialValues={initialValues} validate={validate} onSubmit={signUpWithEmailAndPassword(history)}>
      {({isSubmitting, isValid, submitCount, setErrors, setSubmitting, setStatus, status}) => (
        <Form>
          <Title text="Registration" />
          <InputText type="email" name="email" placeholder="Email Address" />
          <InputText type="password" name="password" placeholder="Password" />

          <Button disabled={isSubmitting}>
            {callToAction} <ArrowIcon />
          </Button>

          <FacebookButton
            onClick={() => {
              setStatus('fb');
            }}
            onError={err => {
              setSubmitting(false);
              setErrors({email: err.message});
              setStatus(null);
              console.warn(err);
            }}
          />

          {/* TODO create unit test */}
          {status !== 'fb' && submitCount > 0 && !isValid && (
            <div className="errors">
              <ErrorIcon />
              <ErrorMessage name="email" />
              <ErrorMessage name="password" />
            </div>
          )}
        </Form>
      )}
    </Formik>
    <Agreement action={callToAction} />
  </AuthForm>
);
